import React from "react";
import autobind from "autobind-decorator";
import JoditEditor from "jodit-react";
import {withTranslation, WithTranslation} from "react-i18next";
import {IdentityProps, withIdentity} from 'src/core/services/authentication';
import HttpService from "../core/services/http.service";
import {Button} from 'antd';
import {withUserProfile} from "./user-profile";

export interface JoditRichEditorProps extends IdentityProps {
  rows?: number;
  value?: string;
  onChange?: (value: string) => void;
  onSave: (value: string) => void;
  readOnly?: boolean;
  placeholder?: string;
  references?: any[];
  maxHeight?: number;
  commentEditor?: boolean;
  initialValue: string
}

class JoditRichEditor extends React.Component<JoditRichEditorProps & WithTranslation, {value: string}> {
  private timer: any;
  value: string;

  constructor(props: JoditRichEditorProps & WithTranslation) {
    super(props);
    this.value = this.props.initialValue
    this.state = {
      value: props.initialValue
    };
    this.value = props.initialValue;
  }


  componentDidUpdate(prevProps: JoditRichEditorProps) {
    if (prevProps.initialValue !== this.props.initialValue) {
      this.value = this.props.initialValue;
      this.setState({ value: this.props.initialValue})
    }
  }

  @autobind
  onChange(newContent: string) {
    clearTimeout(this.timer);
    const self = this;
    this.timer = setTimeout(() => {
      self.value = newContent
      if (self.props.onChange) {
        self.props.onChange!(newContent as string);
      }
    }, 100);
  }

  /**
   * @property Jodit jodit instance of native Jodit
   */
  jodit: any;
  setRef = (jodit: any) => { this.jodit = jodit }

  render() {
    const self = this;
    const { t, readOnly, placeholder } = this.props;
    const lang = this.props.i18n.language.toLowerCase();
    const config = {
      readonly: readOnly, // all options from https://xdsoft.net/jodit/doc/
      placeholder: placeholder ? placeholder : t("Start writing..."),
      askBeforePasteFromWord: false,
      askBeforePasteHTML: false,
      colorPickerDefaultTab: 'color',
      //uploader: {
      //    insertImageAsBase64URI: true
      //},
      enableDragAndDropFileToEditor: true,
      uploader: {
        data: null,
        url: 'api/v1/files/jodit',  //your upload api url
        insertImageAsBase64URI: false,
        imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],

        headers: { "Authorization": `Bearer ${HttpService.accessToken}` },
        filesVariableName: function (t: any) {
          return 'joditFile';
        }, //"files",
        withCredentials: false,
        pathVariableName: 'path',
        format: 'json',
        method: 'POST',
        prepareData: function (formdata: any) {
          return formdata;
        },
        isSuccess: function (e: any) {
          return e.success;
        },
        getMessage: function (e: any) {
          return void 0 !== e.msg && Array.isArray(e.msg)
            ? e.msg.join('')
            : '';
        },
        process: function (this: any, resp: any) { //success callback transfrom data to defaultHandlerSuccess use.it's up to you.
          let files = [];
          files.unshift(resp.data.files);
          return {
            files: files,
            error: resp.msg,
            msg: resp.msg,
            baseurl: ""
          };
        },
        error: function (this: any, e: Error) {
          this.j.e.fire('errorMessage', e.message, 'error', 4000);
        },
        defaultHandlerSuccess: function (this: any, data: any) { // `this` is the editor.
          const j = this.isJodit ? this : this.jodit;
          if (data.files && data.files.length) {
            const tagName = 'img';
            data.files.forEach((filename: string, index: number) => { //editor insertimg function
              const elm = j.createInside.element(tagName);
              elm.setAttribute('src', filename);
              j.s.insertImage(elm as HTMLImageElement, null, j.o.imageDefaultWidth);
            });
          }
        },
        defaultHandlerError: function (this: any, e: any) {
          this.j.e.fire('errorMessage', e.message);
        },
        //contentType: function (e: any): any {
        //  //return (
        //  //  (void 0 === (self.jodit.ownerWindow as any).FormData || 'string' == typeof e) &&
        //    return 'application/x-www-form-urlencoded'
        //  //);
        //},
      },
      language: lang.startsWith('pt') ? 'pt_br' : lang,
      buttons: [
        'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', 'outdent', 'indent', 'align', '|',
        'font', 'fontsize', 'brush', 'paragraph', '|',
        'image', 'table', 'link', '|',
        'undo', 'redo', '|', 'search'
      ],
      useSearch: true,
      extraButtons: [
      ],
      events: {
      }
    }

    if (this.props.maxHeight) {
      (config as any)["maxHeight"] = this.props.maxHeight
    }

    if (this.props.references && this.props.references.length > 0) {

      (config as any).extraButtons.push(
        {
          name: t('Add reference'),
          tooltip: t('Add a reference selecting it from the list'),
          list: this.props.references,
          exec: (jodit: any, current: any, options: any) => {
            if (options.control.args) {
              var value = options.control.args[0]
              jodit.s.insertHTML('{' + value + '}');
            }
          },
          template: function (key: any, value: any) {
            return '<div>' + value + '</div>';
          },
          mode: 3
        }
      );
    }
    return <div>
      <JoditEditor
        ref={this.setRef}
        value={this.value ? this.value : ''}
        onChange={value => this.onChange(value)}
        config={config as any}
      />
      {!this.props.readOnly && < Button type='primary' onClick={() => this.props.onSave(this.value || "")} style={{ float: 'right' }}>{t("Save")}</Button >}
    </div>
  }
}

export default withUserProfile(withIdentity((withTranslation()(JoditRichEditor)) as any));